
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
export default Vue.extend({
  props: {
    show: Boolean
  },
  computed: {
    ...mapState(["ErrorDialogShow", "ServerError"])
  },
  methods: {
    close() {
      this.modify({ property: "ErrorDialogShow", value: false });
    },
    ...mapMutations(["modify"])
  }
});
